<template>
  <div>
    <bank-list-desktop-bridge v-if="isDesktopListLayout" />
    <bank-list-mobile v-else />
    <dialog-component
          :dialog-prop="innerComponent"
          :data-prop="dialogData"
          @close="innerComponent = false"
        />
          <v-dialog
          :fullscreen="isMobile"
          :hide-overlay="isMobile"
          v-model="printDialog"
          width="70%"
        >
          <v-card>
            <v-col
              class="d-flex pb-0"
            >
              <v-btn
                icon
                color="grey darken-2"
                @click="printDialog = false"
              >
                <v-icon
                  class="close-hover"
                  large
                >
                  mdi-close
                </v-icon>
              </v-btn>
              <p class="mx-auto font-weight-medium mt-2">
                {{ $t('print') }}
              </p>
            </v-col>
            <v-row class="ma-0">
              <print
                :header-prop="showHeaders"
                :items-prop="items"
                :title="$t($route.name)"
              />
            </v-row>
            <v-card-actions />
          </v-card>
        </v-dialog>
          <v-dialog
            v-model="filter"
            :fullscreen="isMobile"
            :hide-overlay="isMobile"
            max-width="720"
            scrollable
            content-class="acf-wrap"
          >
            <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
              <header class="acf-head">
                <span class="acf-head__icon">
                  <v-icon size="18">mdi-filter-variant</v-icon>
                </span>
                <div class="acf-head__titles">
                  <div class="acf-head__title">{{ bankFilterDialogTitle }}</div>
                  <div class="acf-head__sub">
                    <template v-if="activeFilterChips.length">
                      <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                      {{ $t("accFilterActive") }}
                    </template>
                    <template v-else>{{ $t("accFilterNone") }}</template>
                  </div>
                </div>
                <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
                  <v-icon size="18">mdi-close</v-icon>
                </button>
              </header>

              <div class="acf-body">
                <section class="acf-sec">
                  <div class="acf-sec__head">
                    <v-icon size="17">mdi-shape-outline</v-icon>
                    {{ $t("bankFilterStatus") }}
                  </div>
                  <div class="acf-grid acf-grid--3">
                    <v-select
                      v-model="productStatus"
                      :label="$t('status')"
                      :items="productStatusItems"
                      dense
                      outlined
                      multiple
                      hide-details
                      item-value="value"
                      item-text="text"
                    >
                      <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                        <span v-if="index === 1" class="acf-sel acf-sel--more">
                          +{{ faNum((productStatus || []).length - 1) }}
                        </span>
                      </template>
                    </v-select>
                    <status v-model="sellStatus" :hideconfig="true" />
                    <tag v-model="tag" />
                  </div>
                </section>
              </div>

              <footer class="acf-foot">
                <button type="button" class="acf-btn acf-btn--primary" @click="applyBankFilter">
                  <v-icon size="16">mdi-filter-check-outline</v-icon>
                  {{ $t("accFilterApply") }}
                </button>
                <button
                  type="button"
                  class="acf-btn acf-btn--ghost"
                  :disabled="!activeFilterChips.length"
                  @click="resetFilters"
                >
                  <v-icon size="16">mdi-filter-remove-outline</v-icon>
                  {{ $t("accDocListClearFilters") }}
                </button>
                <span class="acf-spacer" />
                <button type="button" class="acf-btn" @click="filter = false">
                  {{ $t("cancel") }}
                </button>
              </footer>
            </div>
          </v-dialog>
          <v-dialog
          :fullscreen="isMobile"
          :hide-overlay="isMobile"
          v-model="taskDialog"
          width="90%"
        >
          <v-card>
            <v-col
              class="d-flex"
            >
              <v-btn
                icon
                color="grey darken-2"
                @click="taskDialog = false"
              >
                <v-icon
                  class="close-hover"
                  large
                >
                  mdi-close
                </v-icon>
              </v-btn>
              <p class="mx-auto font-weight-medium mt-2">
                {{ $t('task') }}
              </p>
            </v-col>
            <v-row class="ma-0">
              <task
                task-type="account"
                :ref-id="refId"
                :task-id="taskId"
                @close="taskDialog = false"
              />
            </v-row>
            <v-card-actions />
          </v-card>
        </v-dialog>
          <v-dialog
          :fullscreen="isMobile"
          :hide-overlay="isMobile"
          v-model="deletDialog"
          width="400"
        >
          <v-card>
            <v-col>
              <v-btn
                icon
                class="close-hover"
                @click="deletDialog = false"
              >
                <v-icon
                  color="grey"
                  large
                >
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-img
                class="mx-auto"
                width="200"
                src="@/assets/stop.svg"
              />
            </v-col>
            <v-col
              class="mt-3 pr-7"
            >
              <p class="mx-auto font-weight-medium">
                {{ $t('are-you-sure-delete-this-case') }}
              </p>
            </v-col>
            <v-card-actions>
              <v-row class="ma-0">
                <v-col cols="6">
                  <v-btn
                    v-if="selected.length > 0"
                    color="primary"
                    @click="removegroup"
                  >
                    {{ $t('remove') }}
                  </v-btn>
                  <v-btn
                    v-if="selected.length == 0"
                    color="primary"
                    @click="remove"
                  >
                    {{ $t('remove') }}
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    color="grey"
                    outlined
                    class="float-left"
                    @click="deletDialog = false"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <snakbar
          v-model="snakbar"
          :text="snakbarText"
          :active="snakbar"
          :color="snakbarColor"
        />
  </div>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
import BankListDesktopBridge from './layouts/desktop/BankListDesktopBridge.vue'
import BankListMobile from './layouts/mobile/BankListMobile.vue'
  import ProList from '@/Mixins/proList'
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  import ProListFrame from '@/components/proList/ProListFrame.vue'
  export default {
    name: 'bankList',
    provide () {
      return { bankList: this }
    },
    components: {
      BankListDesktopBridge,
      BankListMobile,
      ProListFrame,
      PrintStudio,
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Print,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      selected: [],
      selectedHeaders: [],
      printDialog: false,
      deletDialog: false,
      showSelect: true,
      filter: false,
      dialogData: null,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      pageCount: 1,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      // Separate from General mixin money `options` (beforeMount overwrites it).
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: null,
      type: null,
      listViewportObserver: null,
      listViewportRaf: null,
      search: null,
    }),
    computed: {
      proListKey () {
        return 'treasury-bank-list-columns-' + (this.$route.name || 'bank')
      },
      proListLocked () {
        return this.bankListLockedColumns
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          return app.selectedHeaders.includes(s)
        })
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      isDesktopListLayout () {
        if (this.mobileShow) return true
        return this.$vuetify.breakpoint.width >= 800
      },
      isDesktopListViewport () {
        return !this.isMobile && !this.mobileShow
      },
      bankFilterDialogTitle () {
        if (this.type === 'petty') return this.$t('pettyFilterTitle')
        if (this.type === 'cash') return this.$t('cashFilterTitle')
        return this.$t('bankFilterTitle')
      },
      activeFilterChips () {
        var app = this
        var has = function (v) {
          if (Array.isArray(v)) return v.length > 0
          return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
        }
        var show = function (v) {
          if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
          if (v && typeof v === 'object') return v.name || v.text || v.label || ''
          return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
        }
        var pick = function (items, v, key) {
          var arr = Array.isArray(v) ? v : [v]
          return arr
            .map(function (x) {
              var f = (items || []).find(function (i) {
                return i.value === x
              })
              return f ? f[key || 'text'] : ''
            })
            .filter(Boolean)
            .join('، ')
        }
        var defs = [
          ['productStatus', app.$t('status'), pick(app.productStatusItems, app.productStatus)],
          ['sellStatus', app.$t('status')],
          ['tag', app.$t('tag')],
        ]
        return defs
          .filter(function (d) {
            return has(app[d[0]])
          })
          .map(function (d) {
            return {
              key: d[0],
              label: d[1],
              value: d.length > 2 ? d[2] : show(app[d[0]]),
            }
          })
      },
      bankListColumnPersistKey () {
        return 'treasury-bank-list-columns-' + (this.$route.name || 'bankList')
      },
      bankListLockedColumns () {
        // Fixed sticky block: select + actions + id (no unpin/drag)
        var locked = ['actions', 'id']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      bankListColumnPlugins () {
        // show-select inserts a leading checkbox <th>; pad visibleHeaders so
        // pin/resize/drag index mapping stays aligned with thead cells.
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.bankListLockedColumns,
          anchor: 'id',
          minWidth: 60,
          persistKey: this.bankListColumnPersistKey,
        }
      },
      bankListPageCount () {
        var perPage = (this.tableOptions && this.tableOptions.itemsPerPage) || 10
        return Math.max(1, Math.ceil((this.totalItems || 0) / perPage))
      },
      totals: function () {
        const totals = this.items.reduce((acc, d) => {
          acc.sum += (d.remain ? parseFloat(d.remain.remain) : 0)
          acc.discount += parseFloat(0)
          acc.tax += parseFloat(0)
          return acc
        }, {
          sum: 0,
          discount: 0,
          tax: 0,
        })
        return totals
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          if (app.tableOptions && app.tableOptions.page !== 1) {
            app.tableOptions.page = 1
          } else {
            app.getItems()
          }
        }, 1000)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          const sortBy = (app.tableOptions && app.tableOptions.sortBy) || []
          sortBy.forEach(function (value) {
            const index = (app.headers || []).findIndex(h => h.value === value)
            if (index > -1 && app.headers[index].table) {
              app.sortBy.push(app.headers[index].table)
            }
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      loading (val) {
        if (!val && this.isDesktopListViewport) {
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        }
      },
      isDesktopListViewport (val) {
        if (val) {
          this.$nextTick(() => {
            this.updateDesktopTableHeight()
            this.bindListViewportObserver()
          })
        } else {
          this.unbindListViewportObserver()
          this.tableHeight = window.innerHeight - 245
        }
      },
    },
    activated () {
      this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.scheduleDesktopTableHeightUpdate()
        })
      }
    },
    beforeMount () {
      if (this.$route.name === 'bankList') {
        this.type = 'bank'
      }
      if (this.$route.name === 'cashList') {
        this.type = 'cash'
      }
      if (this.$route.name === 'pettyList') {
        this.type = 'petty'
      }
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      this.headers = [
        {
          text: this.$t('#'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 42,
          class: 'pl-action-col',
          cellClass: 'pl-action-col',
        },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'bank_cash.id',
        },
        {
          text: this.$t('name') + ' ' + this.$t(this.type),
          sortable: true,
          value: 'name',
          table: 'bank_cash.name',
        },
        {
          text: this.$t('accountCode'),
          sortable: false,
          value: 'financial.fin_code',
        },
        {
          text: this.$t('number'),
          sortable: false,
          value: 'number',
        },
        {
          text: this.$t('currency'),
          sortable: false,
          value: 'currency',
        },
        {
          text: this.$t('remain') + ' ( ' + this.$store.state.currency.name + ' ) ',
          sortable: false,
          width: 100,
          value: 'remain',
        },
        {
          text: this.$t('status'),
          sortable: false,
          value: 'status',
        },
        {
          text: this.$t('tag'),
          sortable: false,
          value: 'tags',
        },
        {
          text: this.$t('branch-name'),
          sortable: false,
          value: 'branch',
        },
        {
          text: this.$t('Account opening date'),
          sortable: false,
          value: 'date',
        },
        {
          text: this.$t('content'),
          sortable: true,
          value: 'content',
          table: 'bank_cash.content',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
        },
      ]
      
      if (this.type === 'petty') {
        //add extra header for table when user is in petty route
        const extraHeader = {
          text: this.$t('pettyPerson'),
          sortable: false,
          value: 'user_financial',
        }
        const insertIndex = 4
        this.headers.splice(insertIndex, 0, extraHeader)
        //remove a header when we are in petty route
        const removeIndex = this.headers.findIndex(obj => obj.value === 'number')
        if (removeIndex !== -1) {
          this.headers.splice(removeIndex, 1)
        }
      }


      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      }
      reorderPinnedHeaders(this.headers, {
        locked: this.bankListLockedColumns,
        anchor: 'id',
      })
      this.loadBankListColumnSettings()
    },
    mounted () {
      this.selectedHeaders = this.headers
      if (this.input) {
        this.model = this.input
      }
      this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.updateDesktopTableHeight()
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        })
      }
    },
    deactivated () {
      this.unbindListViewportObserver()
    },
    beforeDestroy () {
      this.unbindListViewportObserver()
      if (this.listViewportRaf) {
        cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = null
      }
    },
    methods: {
      resolveRefEl (ref) {
        if (!ref) return null
        return ref.$el || ref
      },
      onResize () {
        if (this.isDesktopListViewport) {
          this.updateDesktopTableHeight()
          return
        }
        this.tableHeight = window.innerHeight - 245
      },
      scheduleDesktopTableHeightUpdate () {
        if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = requestAnimationFrame(() => {
          this.listViewportRaf = null
          this.updateDesktopTableHeight()
        })
      },
      updateDesktopTableHeight () {
        if (!this.isDesktopListViewport) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const toolbarEl = this.resolveRefEl(this.$refs.listToolbar)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        if (!rootEl || !tableColEl) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootStyle = window.getComputedStyle(rootEl)
        const rootPadding =
          (parseFloat(rootStyle.paddingTop) || 0) +
          (parseFloat(rootStyle.paddingBottom) || 0)
        const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0
        let summaryHeight = 0
        if (summaryEl) {
          const summaryVisible =
            summaryEl.offsetParent !== null ||
            summaryEl.getClientRects().length > 0
          if (summaryVisible) {
            const summaryStyle = window.getComputedStyle(summaryEl)
            summaryHeight =
              summaryEl.offsetHeight +
              (parseFloat(summaryStyle.marginTop) || 0) +
              (parseFloat(summaryStyle.marginBottom) || 0)
          }
        }
        const colStyle = window.getComputedStyle(tableColEl)
        const colPadding =
          (parseFloat(colStyle.paddingTop) || 0) +
          (parseFloat(colStyle.paddingBottom) || 0)
        const footerEl = tableEl
          ? tableEl.querySelector('.v-data-footer')
          : null
        const footerHeight = footerEl ? footerEl.offsetHeight : 0
        const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null
        const tableMargins = tableStyle
          ? (parseFloat(tableStyle.marginTop) || 0) +
            (parseFloat(tableStyle.marginBottom) || 0)
          : 0
        const available =
          rootEl.clientHeight -
          rootPadding -
          toolbarHeight -
          summaryHeight -
          colPadding -
          footerHeight -
          tableMargins -
          3
        this.tableHeight = Math.max(180, Math.floor(available))
      },
      bindListViewportObserver () {
        if (typeof ResizeObserver === 'undefined') return
        this.unbindListViewportObserver()
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        const footerEl = tableEl ? tableEl.querySelector('.v-data-footer') : null
        if (!rootEl && !summaryEl && !tableColEl) return
        this.listViewportObserver = new ResizeObserver(() => {
          this.scheduleDesktopTableHeightUpdate()
        })
        if (rootEl) this.listViewportObserver.observe(rootEl)
        if (summaryEl) this.listViewportObserver.observe(summaryEl)
        if (tableColEl) this.listViewportObserver.observe(tableColEl)
        if (footerEl) this.listViewportObserver.observe(footerEl)
      },
      unbindListViewportObserver () {
        if (this.listViewportObserver) {
          this.listViewportObserver.disconnect()
          this.listViewportObserver = null
        }
      },
      loadBankListColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.bankListColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.bankListLockedColumns,
            anchor: 'id',
          })
          app.$forceUpdate()
        })
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      editLink (item) {
        const t = (item && item.type) || this.type || 'bank'
        return this.$baseURL + '/' + t + '/edit/' + item.id
      },
      applyBankFilter () {
        this.filter = false
        this.getItems()
      },
      resetFilters () {
        this.productStatus = null
        this.sellStatus = null
        this.tag = null
      },
      edit (item) {
        this.$router.push({ name: item.type + 'Edit', params: { id: item.id, tabName: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'bank', {
          params: {
            search: app.search,
            page: (app.tableOptions && app.tableOptions.page) || 1,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.from = res.from
            app.pageCount = res.last_page || 1
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'bank/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'bank/0', {
          params: { deleteItems: app.selected },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";
</style>
